// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Material
// Views
// Infrastructure
import { IntegrationsAPI } from "views/Integrations/infrastructure";
// Components
import { AlertInfo } from "@components/Alert";
// Assets
import { arrowRightSvg } from "@assets";
// SVG
import { channelsSvg } from "assets";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: ""
    };
  }

  componentDidMount = () => {
    this.getAppInfo();
  };

  getAppInfo = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new IntegrationsAPI(user.id, access, this.props, user);
      const info = await obj.get_sunco_info();

      this.setState({ info: info });
    } catch (err) {}
  };

  return = () => {
    const { history } = this.props;
    history.push("/integrations/sunco");
  };

  handleRender = () => {
    const { info } = this.state;
    const { t } = this.props;
    const { projects, plan } = this.props.data;
    if (!plan.plan.integrations.sunco) {
      return (
        <div
          className={
            "cen_channels_integration_element cen_channels_integration_alert"
          }
        >
          <AlertInfo
            className={"alert"}
            text={t("sunco.integrate.alert_plan")}
          />
        </div>
      );
    } else if (projects.active.length <= 0) {
      return (
        <div
          className={
            "cen_channels_integration_element cen_channels_integration_alert"
          }
        >
          <AlertInfo className={"alert"} text={t("sunco.integrate.alert")} />
        </div>
      );
    }
    return (
      <div className={"elements_custom"}>
        <div className={"elements_custom__info"}>
          <span className="elements_custom__title">
            {t("integrations:channels.sunco.oauth.title")}
          </span>
          <span className="elements_custom__description">
            {t("integrations:channels.sunco.oauth.description")}
          </span>
        </div>
        <div className="platform_input_content platform_input_link">
          <a
            href={`https://app.smooch.io/oauth/authorize?client_id=centribal&response_type=code&state=admin&redirect_uri=${info.redirect_url}`}
          >
            <div>{channelsSvg("sunco")}</div>
            <span>{t("integrations:channels.sunco.oauth.action_button")}</span>
          </a>
        </div>
      </div>
    );
  };

  render() {
    const { info } = this.state;
    const { t } = this.props;
    return (
      info && (
        <React.Fragment>
          <div className={"cen_integrations"}>
            <div className={"header"}>
              <div className={"header_content"}>
                <div onClick={() => this.return()} className={"header_action"}>
                  {arrowRightSvg()}
                </div>
                <div className={"header_image"}>{channelsSvg("sunco")}</div>
                <div className={"header_title"}>
                  <span className={"title"}>
                    {t("integrations:channels.sunco.title")}
                  </span>
                  <span className={"description"}>
                    {t("integrations:categories.customer")}
                  </span>
                </div>
              </div>
            </div>
            <div className={"integration"}>{this.handleRender()}</div>
          </div>
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_app = connect(mapStateToProps)(Create);

export default withTranslation(["channels", "notifications"])(
  withRouter(connect_app)
);
